<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/entk46/tc-custom/9781453214831.jpg?1704267570822" alt="This image is the cover for the book Fatal Inversion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fatal Inversion
      </h1>
      <p class="bookDescription body article font2">
        <b>An award-winning novel from a <i>New York Times</i>–bestselling author: The long-buried bodies of a woman and child are unearthed on a Suffolk country estate.</b><br/>  <br/> When the new owners of Wyvis Hall, a rural estate in Suffolk, set out to bury their pet dog on the grounds, they stumbled upon a ghastly relic: the bones of a woman and small child in a shallow grave. The gruesome find makes stunning headlines, especially so for the previous occupants.<br/>  <br/> A decade before, nineteen-year-old Adam Verne-Smith inherited the property and spent one debauched summer there with runaways, drifters, and his two best friends—none of whom have spoken since that fatal season. Adam is now a doting father and husband. His old buddy Rufus is a respectable doctor. And there’s Shiva, whose dreams of upward mobility drifted away. Unhinged by the discovery, they reunite, each with a protest of innocence. As the past slowly emerges, their regrets, desperation, and bitter incriminations get the best of them—and so will their secrets.<br/>  <br/> A master of “deep, disquieting insight into the pathological dynamics of love” (<i>The New York Times</i>), author Ruth Rendell’s Crime Writers’ Association Gold Dagger Award–winning <i>A Fatal Inversion</i> is “rife with lost Edens, family secrets and stifled sexual urges” (<i>Chicago Tribune</i>). It was adapted for television by the BBC in 1992.<br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Rendell
      </h2>
      
      <p class="authorDescription body article"><p>Edgar Award&ndash;winning author Ruth Rendell (b. 1930) has written more than seventy books and sold more than twenty million copies worldwide. A fellow of the Royal Society of Literature (London), she is the recipient of the Grand Master Award from the Mystery Writers of America and a Lifetime Achievement Award from the Crime Writers&rsquo; Association. Rendell&rsquo;s award-winning novels include <i>A Demon in My View</i> (1976), <i>A Dark-Adapted Eye </i>(1987), and <i>King Solomon&rsquo;s Carpet </i>(1991). Her popular crime stories featuring Chief Inspector Reginald Wexford were adapted into a long-running British television series (1987&ndash;2000) starring George Baker.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66f259ae